exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#email-index[data-v-4092425f] {\n  display: flex;\n  flex: 1;\n  margin-bottom: -22px;\n}", ""]);

// exports
